import React from 'react';
import PropTypes from 'prop-types';

import TextField from '@material-ui/core/TextField';
import Flatpickr from 'react-flatpickr';

import 'flatpickr/dist/flatpickr.min.css';
import { withStyles } from '@material-ui/core/styles';
import styles from './styles.js';

class DatePickerField extends React.Component {
  constructor(props) {
    super(props);

    this.flatpickrRef = React.createRef();
  }

  render() {
    const {
      classes,
      fieldName,
      value,
      changeHandler,
      placeholder,
      minDate,
      maxDate,
    } = this.props;

    return (
      <React.Fragment>
        <TextField
          variant="outlined"
          id={fieldName}
          name={fieldName}
          value={value}
          onFocus={() => {
            setTimeout(() => {
              this.flatpickrRef.current.flatpickr.open();
            }, 0);
          }}
          onKeyDown={(e) => {
            const flatpickrInstance = this.flatpickrRef.current;
            if (e.key == 'ArrowDown') {
              document
                .querySelector('.flatpickr-day:not(.flatpickr-disabled')
                .focus();
            }
            if (e.key == 'Escape') {
              flatpickrInstance.flatpickr.close();
            }
            if (e.key == 'Enter') {
              flatpickrInstance.flatpickr.toggle();
            }
          }}
          placeholder={placeholder}
          InputProps={{
            readOnly: true,
          }}
          inputProps={{
            className: `${classes.textInput} ${classes.dateInput}`,
          }}
          onClick={() => {
            const flatpickrInstance = this.flatpickrRef.current;
            setTimeout(() => flatpickrInstance.flatpickr.open(), 0);
          }}
          fullWidth
        />
        <div className={classes.datePicker}>
          <Flatpickr
            ref={this.flatpickrRef}
            name={'dateDummy'}
            value=""
            onReady={(_, __, instance) => {
              // Add class to calendar element so we can theme it.
              // This is needed as the calendar exists outside of the component.
              const calendarElement = instance.calendarContainer;
              if (calendarElement) {
                calendarElement.classList.add(classes.datePicker);
              }

              // The default input element is hidden, so hide it ffrom the
              // accessibility API.
              instance.element.tabIndex = -1;
              instance.element.setAttribute('aria-hidden', 'true');
            }}
            onChange={([date]) => {
              changeHandler(fieldName, date);
            }}
            options={{
              // Native mobile date picker can't be used currently due to
              // min date and max date not being respected in Safari.
              disableMobile: 'true',
              minDate: minDate,
              maxDate: maxDate,
              position: 'below',
              locale: {
                weekdays: {
                  shorthand: ['S', 'M', 'T', 'W', 'T', 'F', 'S'],
                  longhand: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
                },
              },
            }}
          />
        </div>
      </React.Fragment>
    );
  }
}

DatePickerField.propTypes = {
  classes: PropTypes.object.isRequired,
  fieldName: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  changeHandler: PropTypes.func.isRequired,
  placeholder: PropTypes.string.isRequired,
  minDate: PropTypes.object,
  maxDate: PropTypes.object,
};

DatePickerField.defaultProps = {
  minDate: null,
  maxDate: null,
};

export default withStyles(styles)(DatePickerField);
